module.exports = __webpack_public_path__ + "img/shaltiel.3ab8b2a7.png";